import { render, staticRenderFns } from "./DeleteOrgRelStaff.vue?vue&type=template&id=5d6115a1"
import script from "./DeleteOrgRelStaff.vue?vue&type=script&lang=js"
export * from "./DeleteOrgRelStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports